<div class="container py-3">
  <fgb-upgrade-banner></fgb-upgrade-banner>
  <fgb-leaderboard [toShow]="20" [LeaderboardType]="LeaderboardType"></fgb-leaderboard>
</div>
